import { FC } from 'react';
import { partition } from 'lodash';

import { SearchInstanceDto } from '@app/components';

import { ContributorsSection } from './ContributorsSection';
import { ContributorsList, ContributorsListProps } from './ContributorsList';

interface FormatContributorsProps
  extends Pick<ContributorsListProps, 'cnBemModalOrPlacement'> {
  contributors: SearchInstanceDto['contributors'];
  isModal?: boolean;
  isVirtualItem?: boolean;
}

export const Contributors: FC<FormatContributorsProps> = ({
  contributors,
  isModal = false,
  cnBemModalOrPlacement,
  isVirtualItem = false,
}) => {
  const [primaryContributors, secondaryContributors] = partition(
    contributors,
    contributor => contributor.primary
  );

  const shouldDisplayNameAsText = isModal || isVirtualItem;

  return (
    <div dir="ltr" data-auto="contributors">
      <ContributorsSection contributors={primaryContributors} isPrimary>
        <ContributorsList
          list={primaryContributors}
          cnBemModalOrPlacement={cnBemModalOrPlacement}
          shouldDisplayNameAsText={shouldDisplayNameAsText}
        />
      </ContributorsSection>
      <ContributorsSection contributors={secondaryContributors}>
        <ContributorsList
          list={secondaryContributors}
          cnBemModalOrPlacement={cnBemModalOrPlacement}
          shouldDisplayNameAsText={shouldDisplayNameAsText}
        />
      </ContributorsSection>
    </div>
  );
};
